// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileMenu_root__HUhLX","search":"MobileMenu_search__CJOQc","topics":"MobileMenu_topics__AkwYy","link":"MobileMenu_link__TBFlM","logo":"MobileMenu_logo__H3Xw2"};